import { ResponseError } from '../../errors';
import {
  fetchWebGetUserFavorites,
  TWebGetUserFavoritesResponse,
} from '../../repositories/favorites/v1/web/get-user-favorites';
import { IApplicationContext } from '../../types/applicationContext';

export async function getUserFavorites(context: IApplicationContext) {
  const res: TWebGetUserFavoritesResponse = await fetchWebGetUserFavorites({
    httpApi: context.httpApi,
    parameters: {},
  });

  if (res.statusCode !== 200) {
    throw new ResponseError({
      domain: 'getUserFavorites',
      message: res.response.message ?? '',
      details: {
        // oxlint-disable-next-line typescript/no-explicit-any
        error: res.response.errors as any,
      },
    });
  }

  return res.response.favoriteEntities;
}
